<template>
    <v-container>
        <loading-spinner v-if="loading"/>
        <template v-else-if="coach">
            <!-- BACK BTN AND COACH NAME -->
            <v-row>
                <v-col cols="12" md="4">
                    <back-button :route="{name: 'company.admin', query: {tab: 'list_coaches'}}"/>
                </v-col>
                <v-col cols="12" md="8" class="coach-name">
                    {{ coachName }}
                </v-col>
            </v-row>
            <!-- IMG AND DETAILS -->
            <v-row>
                <v-col cols="12" md="4">
                    <div class="coach-img" :style="`background-image: url(${coachImg})`"/>
                </v-col>
                <v-col cols="12" md="8">
                    <user-details-card :details="coachDetails"/>
                </v-col>
            </v-row>
            <!-- TABLE BASIC INFO -->
            <v-row>
                <v-col cols="12">
                    <table-basic-info :items="itemsInfo" full-width/>
                </v-col>
            </v-row>
            <!-- STUDENTS -->
            <v-row>
                <v-col cols="12" class="students-section">
                    {{ $t('common.students') }}
                </v-col>
                <v-col cols="12" md="6" lg="4" v-for="(student,i) in students" :key="i">
                    <coach-student-card :student="student"/>
                </v-col>
                <v-col v-if="students.length === 0">
                    {{ $t('common.no_students') }}
                </v-col>
            </v-row>
            <!-- DELETE COACH -->
            <v-row>
                <v-col cols="12" align="right">
                    <confirm-button
                        color="error"
                        :label="$t('admin.unlink')"
                        :title="$t('admin.unlink_coach')"
                        :content="$t('admin.unlink_coach_text')"
                        alert-mode
                        :loading="loadingUnlink"
                        @confirm="onConfirmUnlink"
                        ref="confirmUnlink"
                    />
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import LoadingSpinner from "@/components/common/LoadingSpinner";
import {db} from "@/utils/Firebase";
import BackButton from "@/components/common/BackButton";
import UserDetailsCard from "@/components/common/cards/UserDetailsCard";
import TableBasicInfo from "@/components/elements/table/TableBasicInfo";
import CoachStudentCard from "@/components/common/cards/CoachStudentCard";
import ConfirmButton from "@/components/elements/buttons/ConfirmButton";

export default {
    name: "CoachProfile",
    components: {ConfirmButton, CoachStudentCard, TableBasicInfo, UserDetailsCard, BackButton, LoadingSpinner},
    data() {
        return {
            loading: false,
            coach: null,
            students: [],
            loadingUnlink: false,
        }
    },
    computed: {
        coachId(vm = this) {
            return vm.$route.params.id || null
        },
        age(vm = this) {
            if (!vm.coach.birthDate) return vm.$t('common.not_available_short')
            return vm.$moment().diff(vm.$moment(vm.coach.birthDate.seconds * 1000), 'years')
        },
        birthDate(vm = this) {
            if (!vm.coach.birthDate) return vm.$t('common.not_available_short')
            return vm.$moment(vm.coach.birthDate.seconds * 1000).format('DD-MM-YYYY')
        },
        companyName(vm = this) {
            return vm.coach.coachSubscription.companyName || ''
        },
        coachImg(vm = this) {
            if (!vm.coach.avatar) return vm.imgPlaceholder
            return vm.coach.avatar
        },
        activeStudents(vm = this) {
            return vm.coach?.activeStudents || 0
        },
        activeAssignedRoutines(vm = this) {
            return vm.coach?.activeAssignedRoutines || 0
        },
        groupsStudents(vm = this) {
            return vm.coach?.groupsQuantity || 0
        },
        teamsStudents(vm = this) {
            return vm.coach?.teamsQuantity || 0
        },
        yearExperience(vm = this) {
            return vm.coach?.experience || 0
        },
        coachName(vm = this) {
            return vm.coach?.name || vm.$t('common.not_available_short')
        },
        coachCountry(vm = this) {
            return vm.coach.country?.name || vm.$t('common.not_available_short')
        },
        coachDetails(vm = this) {
            if (!vm.coach) return null
            return [
                {name: vm.$t('common.country'), value: vm.coachCountry},
                {name: vm.$t('common.email'), value: vm.coach.email},
                {name: vm.$t('common.work_in'), value: vm.companyName},
                {name: vm.$t('common.age'), value: vm.age},
                {name: vm.$t('common.birth_date'), value: vm.birthDate},
            ]
        },
        itemsInfo(vm = this) {
            return [
                {name: vm.$t('coach.active_students'), value: vm.activeStudents},
                {name: vm.$t('coach.assigned_routines'), value: vm.activeAssignedRoutines},
                {name: vm.$t('coach.groups_students'), value: vm.groupsStudents},
                {name: vm.$t('coach.teams_students'), value: vm.teamsStudents},
                {name: vm.$t('coach.years_experience'), value: vm.yearExperience},
            ]
        }
    },
    async mounted() {
        const vm = this
        await vm.loadCoach()
    },
    methods: {
        async loadCoach() {
            const vm = this
            vm.loading = true

            let coachRef = await db.collection('users').doc(vm.coachId).get()
            vm.coach = {id: coachRef.id, ...coachRef.data()}
            console.log('vm.coach', vm.coach)
            await vm.loadStudents()

            vm.loading = false
        },
        async loadStudents() {
            const vm = this
            let studentsRef = await db.collection('users')
                .where('studentSubscription.coachId', '==', vm.coachId)
                .limit(6).get()

            vm.students = studentsRef.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }))

            console.log('vm.students',vm.students)
        },
        async onConfirmUnlink() {
            const vm = this
            vm.loadingUnlink = true

            if(vm.coach.coachSubscription.id) await db.collection('subscriptions').doc(vm.coach.coachSubscription.id).delete()

            await db.collection('users').doc(vm.coachId).update({
                accountType: 'coach',
                coachSubscription: null,
            })

            vm.loadingUnlink = false
            vm.$refs.confirmUnlink.hide()
        }
    }
}
</script>

<style scoped>

.coach-name {
    font-weight: 600;
    font-size: 32px;
    line-height: 40px;
    text-align: center;
    color: #03342C;
}

.coach-img {
    border-radius: 38px;
    height: 100%;
    min-height: 150px;
    background-color: rgba(51, 51, 51, .1);
    background-position: center;
    background-size: cover;
}

.students-section {
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    color: #333333;
}

</style>